import { useEffect } from "react";
import { useBrandingAssets } from "@/hooks/useBrandingAssets";

/**
 * Component that dynamically updates the favicon in the document head
 * based on the branding settings stored in the database
 */
export function FaviconManager() {
  const { faviconUrl } = useBrandingAssets();

  useEffect(() => {
    if (!faviconUrl) return;

    // Find existing favicon links
    const existingLinks = document.querySelectorAll("link[rel*='icon']");

    // Remove existing favicon links
    existingLinks.forEach((link) => link.remove());

    // Create new favicon link
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    link.href = faviconUrl;

    // Append to head
    document.head.appendChild(link);

    // Cleanup function
    return () => {
      const currentLink = document.querySelector(`link[href="${faviconUrl}"]`);
      if (currentLink) {
        currentLink.remove();
      }
    };
  }, [faviconUrl]);

  // This component doesn't render anything
  return null;
}
